import { useQuery } from '@tanstack/react-query'
import { fetchApi } from '@/common/lib/fetchApi'
import type { AdminTimesheetSummary } from '@/common/hooks/useAdminTimesheetSummary'

export interface TeamTimesheetEntry {
  employee_id: number
  employee_name: string
  timesheet_id: number | null
  status: string
  total_hours: number
  pay_period: { start_date: string; end_date: string }
}

export interface TeamTimesheetsResponse {
  pay_period: { start_date: string; end_date: string }
  entries: TeamTimesheetEntry[]
}

export function useManagerTimesheets(payPeriodId?: number) {
  const params = payPeriodId != null ? `?pay_period_id=${payPeriodId}` : ''
  return useQuery({
    queryKey: ['manager', 'timesheets', payPeriodId ?? 'current'],
    queryFn: () => fetchApi<TeamTimesheetsResponse>(`/api/manager/timesheets${params}`),
  })
}

export function useManagerTimesheetSummary(startDate?: string) {
  const params = startDate != null ? `?start_date=${startDate}` : ''
  return useQuery({
    queryKey: ['manager', 'timesheet-summary', startDate ?? 'default'],
    queryFn: () => fetchApi<AdminTimesheetSummary>(`/api/manager/timesheets/summary${params}`),
  })
}
